import { Button, Drawer, Icon, useToast } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import React from 'react';
import { useCurrentUser } from '@economic/react-app';
import { Field, Form } from '~/app/shared/components/Form';
import { AttachFilesAndScreenshots } from '~/app/components/Header/Help/mail/AttachFilesAndScreenshots';
import { HelpDrawerView } from '~/app/components/Header/Help/HelpDrawerView';

const SUPPORT_MAIL = 'info@e-conomic.dk';

export function MailView(): React.JSX.Element {
    const toast = useToast();
    const user = useCurrentUser();

    function copyMailToClipboard() {
        try {
            navigator.clipboard.writeText(SUPPORT_MAIL);
            toast(t`Mail copied to clipboard!`, { autoClose: 3000, type: 'success' });
        } catch (err) {
            toast(t`Could not copy mail to clipboard`, { autoClose: 10000, type: 'error' });
        }
    }

    function submitForm(values: unknown) {
        console.log('handle submit', values);
    }

    return (
        <HelpDrawerView title={<Trans>Send us a mail</Trans>}>
            <div className="p-4 overflow-auto flex-1">
                <div className="text-center">
                    <h4 className="mb-0">
                        <Trans>Send a mail to our support</Trans>
                    </h4>
                    <h3 className="inline-flex items-center mb-4">
                        <Button
                            appearance="discrete"
                            className="leading-6 pr-0"
                            onClick={() => copyMailToClipboard()}
                            type="button">
                            {SUPPORT_MAIL}
                            <Icon name="copy" className="text-xs" />
                        </Button>
                    </h3>
                </div>
                <Form id="helpMailForm" onSubmit={submitForm} messages={{ success: t`Mail sent!` }}>
                    <Field.Text
                        label={t`Your name`}
                        name="username"
                        initialValue={`${user.firstName ?? ''} ${user.lastName ?? ''}`}
                        required
                        autoFocus
                    />
                    <Field.Text label={t`Your email`} name="email" initialValue={user.email} required />
                    <Field.Text label={t`Subject`} name="subject" required />
                    <Field.TextArea label={t`Your message`} name="message" required rows={4} />
                    <AttachFilesAndScreenshots />
                </Form>
            </div>
            <Drawer.Footer>
                <Button appearance="primary" type="submit" form="helpMailForm">
                    <Trans>Send mail</Trans>
                </Button>
            </Drawer.Footer>
        </HelpDrawerView>
    );
}
